// --- Get Shipment Planning Data ---
export const SHIPMENT_MANAGER_PLANNING_REQUEST = 'SHIPMENT_MANAGER_PLANNING_REQUEST'
export const SHIPMENT_MANAGER_PLANNING_SUCCESS = 'SHIPMENT_MANAGER_PLANNING_SUCCESS'
export const SHIPMENT_MANAGER_PLANNING_FAIL = 'SHIPMENT_MANAGER_PLANNING_FAIL'
export const SHIPMENT_MANAGER_PLANNING_RESET = 'SHIPMENT_MANAGER_PLANNING_RESET'

// --- Upsert Split (Create or Update) ---
export const SHIPMENT_MANAGER_UPSERT_SPLIT_REQUEST = 'SHIPMENT_MANAGER_UPSERT_SPLIT_REQUEST'
export const SHIPMENT_MANAGER_UPSERT_SPLIT_SUCCESS = 'SHIPMENT_MANAGER_UPSERT_SPLIT_SUCCESS'
export const SHIPMENT_MANAGER_UPSERT_SPLIT_FAIL = 'SHIPMENT_MANAGER_UPSERT_SPLIT_FAIL'
export const SHIPMENT_MANAGER_UPSERT_SPLIT_RESET = 'SHIPMENT_MANAGER_UPSERT_SPLIT_RESET'

// --- Get Grouped Shipment Data (Review) ---
export const SHIPMENT_MANAGER_GROUPED_REQUEST = 'SHIPMENT_MANAGER_GROUPED_REQUEST'
export const SHIPMENT_MANAGER_GROUPED_SUCCESS = 'SHIPMENT_MANAGER_GROUPED_SUCCESS'
export const SHIPMENT_MANAGER_GROUPED_FAIL = 'SHIPMENT_MANAGER_GROUPED_FAIL'
export const SHIPMENT_MANAGER_GROUPED_RESET = 'SHIPMENT_MANAGER_GROUPED_RESET'

// --- Delete Split ---
export const SHIPMENT_MANAGER_DELETE_SPLIT_REQUEST = 'SHIPMENT_MANAGER_DELETE_SPLIT_REQUEST'
export const SHIPMENT_MANAGER_DELETE_SPLIT_SUCCESS = 'SHIPMENT_MANAGER_DELETE_SPLIT_SUCCESS'
export const SHIPMENT_MANAGER_DELETE_SPLIT_FAIL = 'SHIPMENT_MANAGER_DELETE_SPLIT_FAIL'
export const SHIPMENT_MANAGER_DELETE_SPLIT_RESET = 'SHIPMENT_MANAGER_DELETE_SPLIT_RESET'
